import Modal from '@/components/modals/modal/modal.vue';

export default {
  name: 'DeleteRouteModal',
  components: { Modal },
  data() {
    return {
      loading: false,
      form: {
        reason_key: '',
        comment: '',
        reserved_time_minutes: '',
        travel_time_minutes: '',
      },
      reasonOptions: [
        {
          value: 'incorrect_time_calculation',
          label: 'Некорректный подсчет времени',
        },
        {
          value: 'incorrect_order_count',
          label: 'Некорректное количество заказов',
        },
        {
          value: 'incorrect_order_sequence',
          label: 'Некорректный порядок заказов',
        },
        { value: 'other', label: 'Другое' },
      ],
      isCommentRequired: false,
    };
  },
  computed: {
    isOtherReasonSelected() {
      return this.form.reason_key === 'other';
    },
    showCommentError() {
      return this.isOtherReasonSelected && !this.form.comment;
    },
    isSubmitDisabled() {
      return (
        this.loading ||
        !this.form.reason_key ||
        (this.isOtherReasonSelected && !this.form.comment)
      );
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    resetForm() {
      this.form = {
        reason_key: '',
        comment: '',
      };
      this.loading = false;
    },
    handleReasonChange() {
      if (!this.isOtherReasonSelected) {
        this.form.comment = '';
      }
    },
    async submit() {
      if (this.isSubmitDisabled) return;

      this.loading = true;
      try {
        await this.$emit('submit', this.form);
        this.hide();
      } finally {
        this.loading = false;
      }
    },
  },
};
